import React from 'react';
import { SkeletonGroup, SkeletonRectangle } from '@wix/design-system';
import { SearchRecommendationModule } from '../SearchRecommendation/SearchRecommendation.module';
import styles from './Pricing.module.scss';
export const PricingSection = _ref => {
  let {
    pricing,
    tld,
    domainName,
    useMobileLayout = false,
    denseStrikethroughStyle = false,
    useIntroPriceLabelCopy = false,
    matchStrikethroughSize = false,
    isPricingLoading = false,
    exactMatch = false,
    compactPriceLabel = false
  } = _ref;
  const {
    PricingWrapper,
    PricingContent
  } = SearchRecommendationModule.SDK.Layouts;
  if (!pricing || !pricing.price) {
    if (!isPricingLoading) {
      return null;
    }
    return /*#__PURE__*/React.createElement(SkeletonGroup, {
      skin: "light",
      className: useMobileLayout ? styles.mobileSkeletonGroup : styles.skeletonGroup
    }, /*#__PURE__*/React.createElement(PricingWrapper, {
      direction: "vertical",
      gap: useMobileLayout ? '4px' : 'SP1',
      align: useMobileLayout ? 'left' : 'right'
    }, /*#__PURE__*/React.createElement(SkeletonRectangle, {
      className: styles.skeleton,
      width: useMobileLayout ? '139px' : '115px',
      height: useMobileLayout ? '20px' : '16px'
    }), /*#__PURE__*/React.createElement(SkeletonRectangle, {
      className: styles.skeleton,
      width: useMobileLayout ? '139px' : '138px',
      height: useMobileLayout ? '20px' : '16px'
    })));
  }
  return /*#__PURE__*/React.createElement(PricingWrapper, {
    direction: "vertical",
    gap: "SP1",
    align: useMobileLayout ? 'left' : 'right'
  }, /*#__PURE__*/React.createElement(PricingContent, {
    pricing: pricing,
    tld: tld,
    domainName: domainName,
    denseStrikethroughStyle: denseStrikethroughStyle,
    useIntroPriceLabelCopy: useIntroPriceLabelCopy,
    matchStrikethroughSize: matchStrikethroughSize,
    exactMatch: exactMatch,
    compactPriceLabel: compactPriceLabel
  }));
};
//# sourceMappingURL=PricingSection.js.map